module.exports = __webpack_public_path__ + "img/cases_blue.22803656.svg";